import styled from 'styled-components';
import NavLink from '../link';

const StyledNavLink = styled(NavLink).attrs({ state: { via: 'NavLink' } })`
  display: inline-flex;
  gap: 0.3rem;
  padding: 1rem;
`;

export default StyledNavLink;
